import { useState } from "react";
import Board from "@asseinfo/react-kanban";
import ColumnHeader from "./columnHeader";
import images from "../../assets/images";
import "@asseinfo/react-kanban/dist/styles.css";
import "./board.scss";

interface Card {
  id: number;
  title: string;
  description: string;
}

interface Column {
  id: number;
  title: string;
  cards: Card[];
}

interface BoardData {
  columns: Column[];
}

interface DraftCard {
  title: string;
  description: string;
}

interface BoardWrapperProps {
  data: BoardData;
}

export const BoardWrapper = (props: BoardWrapperProps) => {
  const [board, setBoard] = useState(props.data);
  const [isAddingColumn, setIsAddingColumn] = useState(false);
  const [newColumnTitle, setNewColumnTitle] = useState("");

  const handleAddColumn = (title: string) => {
    const newColumnAdded = { ...board };
    newColumnAdded.columns.push({
      id: Date.now(),
      title: title,
      cards: [],
    });
    setBoard(newColumnAdded);
    setIsAddingColumn(false);
    setNewColumnTitle("");
  };

  return (
    <div className="card-board-wrap">
      <Board
        initialBoard={board}
        allowAddCard
        allowAddColumn
        renderColumnHeader={(column: Column) => (
          <div className="column-header">
            <ColumnHeader key={column.id} column={column} />
          </div>
        )}
        renderColumnAdder={() =>
          isAddingColumn ? (
            <div className="create-status-box">
              <input
                type="text"
                placeholder="Enter new status title"
                value={newColumnTitle}
                onChange={(e) => setNewColumnTitle(e.target.value)}
              />
              <div className="add-btns">
                <button onClick={() => handleAddColumn(newColumnTitle)}>
                  Add
                </button>
                <button onClick={() => setIsAddingColumn(false)}>Cancel</button>
              </div>
            </div>
          ) : (
            <div
              className="create-status-box"
              onClick={() => setIsAddingColumn(true)}
              role="button"
            >
              Create new status
              <img src={images.common.addIcon} alt="add icon" />
            </div>
          )
        }
        allowRemoveCard
        allowRenameColumn
        onCardNew={console.log}
        onCardRemove={console.log}
        onColumnRemove={console.log}
        onColumnRename={console.log}
        onNewCardConfirm={(draftCard: DraftCard) => ({
          id: new Date().getTime(),
          ...draftCard,
        })}
      />
    </div>
  );
};

export default BoardWrapper;
